<idt-common-styles-render
  *ngIf="piece"
  [styles]="piece.settings?.styles">

  @let orientation = orientation$ | async;
  <ng-container>
    <div class="image-with-markers">
      <!-- eslint-disable @angular-eslint/template/no-call-expression -->
      <render-link
        *ngIf="!!settings?.general?.link?.type; else noLinkImage"
        [lang]="lang"
        [link]="settings!.general!.link"
        [piece]="piece">
        <ng-container *ngTemplateOutlet="image; context: { $implicit: orientation }"></ng-container>
      </render-link>

      <ng-template #noLinkImage>
        <ng-container *ngTemplateOutlet="image; context: { $implicit: orientation }"></ng-container>
      </ng-template>

      <div
        *ngIf="(linkedProducts$ | async) as linkedProducts"
        class="markers">
        <ng-container *ngFor="let linkedProduct of (linkedProducts | getAvailableLinkedProducts: piece!.settings!.general!.linkedProducts); trackBy: trackByIndex">
          <render-link
            *ngIf="linkedProduct.orientation === orientation"
            [style.left]="linkedProduct.posX + '%'"
            [style.top]="linkedProduct.posY + '%'"
            [lang]="lang"
            [piece]="piece"
            [link]="getProductLink(linkedProduct)">
            <div (click)="onProductClick(linkedProduct, linkedProducts)">
              <img
                *ngIf="settings?.general?.customMarkerIcon?.image; else defaultIcon"
                alt="loading"
                [src]="customMarkerIcon">
              <ng-template #defaultIcon>
                <svg viewBox="0 0 30 30">
                  <circle
                    cx="15"
                    cy="15"
                    r="14.5"
                    fill="white"
                    fill-opacity="0.25"
                    stroke="white"/>
                  <circle
                    cx="15"
                    cy="15"
                    r="3.75"
                    fill="white"
                    stroke="#999999"
                    stroke-width="0.5"/>
                </svg>
              </ng-template>
              <div
                *ngIf="showTooltips"
                [class]="getTooltipClass(linkedProduct.tooltipPos)">
                <div>
                  <div *ngIf="(linkedProducts | getLinkedProductById: linkedProduct.product) as product">
                    <div
                      *ngIf="piece?.settings?.general?.showNameInTooltip && product.name"
                      class="tooltip-product-name">
                        {{ product.name }}
                    </div>
                    <ng-container *ngIf="piece?.settings?.general?.showPriceInTooltipToggle && product.priceInfo">
                      <div class="tooltip-product-price-info">
                        <span class="tooltip-product-price">
                          {{ product.priceInfo.priceWithCurrencySymbol }}
                        </span>
                        <span
                          *ngIf="piece?.settings?.general?.showOldPriceInTooltip && product.priceInfo.oldPriceWithCurrencySymbol"
                          class="tooltip-product-old-price">
                          {{ product.priceInfo.oldPriceWithCurrencySymbol }}
                        </span>
                      </div>
                      <div
                        *ngIf="product.priceInfo.localePriceWithCurrencySymbol"
                        class="tooltip-local-product-price-info">
                        <span class="tooltip-product-price">
                          {{ product.priceInfo.localePriceWithCurrencySymbol }}
                        </span>
                        <span
                          *ngIf="piece?.settings?.general?.showOldPriceInTooltip && product.priceInfo.oldLocalePriceWithCurrencySymbol"
                          class="tooltip-product-old-price">
                          {{ product.priceInfo.oldLocalePriceWithCurrencySymbol }}
                      </span>
                      </div>
                    </ng-container>
                  </div>
                  <div class="tooltip-arrow">
                    <svg viewBox="0 0 15 8">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.0243 0.651751C14.0243 0.735918 13.9935 0.820917 13.931 0.886751L7.60763 7.58342C7.54347 7.65175 7.45263 7.69092 7.35847 7.69092C7.2643 7.69092 7.17347 7.65175 7.1093 7.58342L0.784299 0.887584C0.654299 0.749251 0.660966 0.53175 0.798466 0.402584C0.935966 0.272584 1.15347 0.278417 1.28347 0.415917L7.35847 6.84842L13.4318 0.415917C13.5618 0.278417 13.7785 0.272584 13.9168 0.402584C13.9885 0.470084 14.0243 0.560917 14.0243 0.651751"
                        fill="#414141"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </render-link>
        </ng-container>
      </div>
    </div>
  </ng-container>
</idt-common-styles-render>

<ng-template
  #image
  let-orientation>
    <img
      *ngIf="orientation === 'landscape'"
      alt="{{ settings?.general?.alt ?? '' }}"
      [lazySrc]="getLandscapeImageSrc()"
      [preRender]="!!settings?.general?.preloadImage"
      [attr.title]="settings?.general?.title" />
    <img
      *ngIf="orientation === 'portrait'"
      alt="{{ settings?.general?.alt ?? '' }}"
      [lazySrc]="getPortraitImageSrc()"
      [preRender]="!!settings?.general?.preloadImage"
      [attr.title]="settings?.general?.title" />
</ng-template>
<!-- eslint-enable @angular-eslint/template/no-call-expression -->
